/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Marimo Gateway API
 * API for managing marimo kernel sessions and proxying kernel requests
 * OpenAPI spec version: 0.0.0
 */
/**
 * Session lifecycle state
 */
export type SessionResponseStatus =
  (typeof SessionResponseStatus)[keyof typeof SessionResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SessionResponseStatus = {
  starting: "starting",
  running: "running",
  stopped: "stopped",
  error: "error",
} as const;

export interface SessionResponse {
  /** Session identifier */
  sessionId: string;
  /** Session lifecycle state */
  status: SessionResponseStatus;
  /** WebSocket URL for kernel output and status updates */
  wsUrl: string;
}

export interface Error {
  /** Error message */
  error?: string;
}

/**
 * Persisted display output for a single marimo cell — matches the
`output` field of a marimo `cell-op` WebSocket message.

 */
export interface MarimoCellOutput {
  /** MIME type of the output payload */
  mimetype: string;
  /** Output channel (typically `output`) */
  channel: string;
  /** Output payload. Shape depends on `mimetype` — usually a string
(HTML, text, base64 data URL), but may be a JSON object/array
(e.g. for `application/vnd.marimo+mimebundle`).
 */
  data?: unknown;
  /** Float seconds since epoch when the output was produced by the
kernel.
 */
  timestamp: number;
}

/**
 * Node in the package dependency tree. Each node represents one
installed package and lists its direct dependencies.

 */
export interface PackageDependencyNode {
  name: string;
  /** @nullable */
  version: string | null;
  dependencies?: PackageDependencyNode[];
}

export type MarimoUsageMemory = {
  total: number;
  available: number;
  percent: number;
  used: number;
  free: number;
  has_cgroup_mem_limit: boolean;
};

export type MarimoUsageCpu = {
  percent: number;
};

/**
 * CPU / memory usage snapshot for the marimo kernel pod. Matches
the shape of marimo's `GET /api/usage` endpoint.

 */
export interface MarimoUsage {
  memory: MarimoUsageMemory;
  cpu: MarimoUsageCpu;
}

/**
 * @nullable
 */
export type PackageTreeResponseTree = PackageDependencyNode | null;

export interface PackageTreeResponse {
  /** @nullable */
  tree?: PackageTreeResponseTree;
}

export interface AddPackageRequest {
  /** Pip-installable spec — a name, name with version, VCS URL,
wheel URL, or local path.
 */
  package: string;
  upgrade?: boolean;
  /**
   * Optional dependency group (advanced; usually omitted).
   * @nullable
   */
  group?: string | null;
}

export interface RemovePackageRequest {
  package: string;
  /** @nullable */
  group?: string | null;
}

export interface PackageOperationResponse {
  success: boolean;
  /** @nullable */
  error?: string | null;
}

/**
 * Internal server error
 */
export type InternalServerErrorResponse = Error;

/**
 * Missing, invalid, expired, or subject-mismatched bearer token. The
gateway verifies signature, expiry, and `sub == documentId` together —
any of those failing returns 401.

 */
export type UnauthorizedResponse = Error;

export type GetHealth200 = {
  status?: string;
};

export type StopMarimoSession200 = {
  success?: boolean;
};

export type MarimoKernelRunBody = {
  /** Cell IDs to run, in order */
  cellIds: string[];
  /** Source code for each cell (parallel to cellIds) */
  codes: string[];
};

/**
 * Kernel response (opaque; varies by endpoint)
 */
export type MarimoKernelRun200 = { [key: string]: unknown };

export type MarimoKernelSyncGraphBody = {
  /** All cell IDs in the document */
  cellIds: string[];
  /** Source code for each cell (parallel to cellIds) */
  codes: string[];
  /** Cell IDs to execute */
  runIds: string[];
};

/**
 * Kernel response (opaque)
 */
export type MarimoKernelSyncGraph200 = { [key: string]: unknown };

export type MarimoKernelDeleteBody = {
  /** ID of the cell to delete from the kernel registry */
  cellId: string;
};

/**
 * Kernel response (opaque)
 */
export type MarimoKernelDelete200 = { [key: string]: unknown };
